import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Alert,
} from '@mui/material';
import {
  CreditCard,
  Receipt,
  AttachMoney,
  Security,
  Construction,
} from '@mui/icons-material';
import ProfileLayout from '../common/components/userProfile/ProfileLayout';

const ProfilePaymentPage: React.FC = () => {
  const mockPaymentMethods = [
    {
      id: '1',
      type: 'Visa',
      last4: '4242',
      expiry: '12/26',
      isDefault: true,
    },
    {
      id: '2',
      type: 'MasterCard',
      last4: '8888',
      expiry: '08/25',
      isDefault: false,
    },
  ];

  const mockInvoices = [
    {
      id: 'inv_001',
      date: '2024-01-01',
      amount: '$9.99',
      status: 'Paid',
      plan: 'Pro Plan',
    },
    {
      id: 'inv_002',
      date: '2023-12-01',
      amount: '$9.99',
      status: 'Paid',
      plan: 'Pro Plan',
    },
  ];

  return (
    <ProfileLayout>
      <Box display="flex" flexDirection="column" gap={3}>
        {/* Coming Soon Alert */}
        <Alert severity="info" icon={<Construction />}>
          <Typography variant="body1" fontWeight="medium">
            Payment Management - Coming Soon!
          </Typography>
          <Typography variant="body2">
            This section is currently under development. Payment features will
            be available in a future update.
          </Typography>
        </Alert>

        {/* Payment Methods Section */}
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
              <Typography variant="h6">Payment Methods</Typography>
              <Chip label="Future Feature" color="secondary" size="small" />
            </Box>

            <List>
              {mockPaymentMethods.map((method) => (
                <ListItem key={method.id} divider>
                  <ListItemIcon>
                    <CreditCard />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body1">
                          {method.type} ••••{method.last4}
                        </Typography>
                        {method.isDefault && (
                          <Chip label="Default" size="small" color="primary" />
                        )}
                      </Box>
                    }
                    secondary={`Expires ${method.expiry}`}
                  />
                  <Button variant="outlined" size="small" disabled>
                    Edit
                  </Button>
                </ListItem>
              ))}
            </List>

            <Box mt={2}>
              <Button variant="contained" startIcon={<CreditCard />} disabled>
                Add Payment Method
              </Button>
            </Box>
          </CardContent>
        </Card>

        {/* Billing History Section */}
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
              <Typography variant="h6">Billing History</Typography>
              <Chip label="Future Feature" color="secondary" size="small" />
            </Box>

            <List>
              {mockInvoices.map((invoice) => (
                <ListItem key={invoice.id} divider>
                  <ListItemIcon>
                    <Receipt />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="body1">{invoice.plan}</Typography>
                        <Chip
                          label={invoice.status}
                          size="small"
                          color="success"
                          variant="outlined"
                        />
                      </Box>
                    }
                    secondary={`${invoice.date} • ${invoice.amount}`}
                  />
                  <Button variant="outlined" size="small" disabled>
                    Download
                  </Button>
                </ListItem>
              ))}
            </List>

            <Box mt={2}>
              <Button variant="outlined" startIcon={<Receipt />} disabled>
                View All Invoices
              </Button>
            </Box>
          </CardContent>
        </Card>

        {/* Upgrade Plan Section */}
        <Card>
          <CardContent>
            <Box display="flex" alignItems="center" gap={2} mb={3}>
              <Typography variant="h6">Plan Management</Typography>
              <Chip label="Future Feature" color="secondary" size="small" />
            </Box>

            <Typography variant="body2" color="text.secondary" mb={3}>
              Upgrade your plan to get more storage and premium features
            </Typography>

            <Box display="flex" gap={2}>
              <Button
                variant="contained"
                startIcon={<AttachMoney />}
                color="primary"
                disabled
              >
                Upgrade to Pro
              </Button>
              <Button variant="outlined" startIcon={<Security />} disabled>
                Billing Settings
              </Button>
            </Box>
          </CardContent>
        </Card>

        {/* Security Notice */}
        <Alert severity="success" icon={<Security />}>
          <Typography variant="body2">
            <strong>Secure Payments:</strong> All payment information is
            encrypted and processed securely through Stripe. We never store your
            credit card details on our servers.
          </Typography>
        </Alert>
      </Box>
    </ProfileLayout>
  );
};

export default ProfilePaymentPage;
